import React from 'react'
import Teaser from '../Teaser'

const ShopAndScheduleTeaser = props =>
  <Teaser displayAsButton { ...props } />

export default ShopAndScheduleTeaser
